import { Component, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '../../../shared/services/auth.service';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeader {

  userDetails: any;

  constructor(private el: ElementRef,
    private _authService: AuthService,
    private _router: Router,
    private _localStorageService:LocalStorageService
  ) { }

  //wait for the component to render completely
  ngOnInit(): void {
    let nativeElement: HTMLElement = this.el.nativeElement,
    parentElement: HTMLElement = nativeElement.parentElement;
    // move all children out of the element
    while (nativeElement.firstChild) {
      parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);
    this.userDetails = this._localStorageService.retrieve('userDetails');
  }

  logout() {
    this._authService.logout().then(value => {
      this._localStorageService.clear();
      this._router.navigate(['/login']);
    })
  }

  goToHome() {
    this._router.navigate(['/home/dashboard']);
  }

  goToChangePassword() {
    this._router.navigate(['/home/change-password']);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/app-header/app-header.component.ts